export default __webpack_public_path__ + "static/amenagement-perron-dimensions-3350132f4bee0c3882391e2145771061.png";